const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import * as telegram from "./telegram"
import * as utils from "./utils"
import * as utils_time from "./utils_time"
import * as utils_topshot from "./utils_topshot"
import { Moment } from './Moment';
import { Account } from './Account';
import { Auction, auctionStatus } from './Auction';
import { TokenUser } from './TokenUser';

export type sortOrderTypes = 'ListedDate_DESC' | 'CurrentPrice_ASC' | 'CurrentPrice_DESC' | 'Serial_ASC' | 'EndDate_ASC' | 'EndDate_DESC'

export enum filterTypes {
  Live = 1, Won = 2, Sold = 3, AwaitingFulfillment = 5, AwaitingFeedback = 6, Lost = 7, Unsold = 8
}

// WAIT, do I just make it so MomentMPListing can handle auctions? Nah, for now, let's keep them separate

export class AuctionListing extends Moment {
  public auction: Auction = null
  public sellerAddress: string = null
  public sellerUsername: string = null
  public sellerImageURL: string = null
  public sellerWhenJoined: Date = null
  public sellerCollectorScore: number = null
  public sellerFeedbackRating: number = null
  public sellerAuctionScore: number = null
  public discount: number = null
  public usersHighestBid: number = null       // special because specific to the logged-in user
  public winningAddress: string = null
  public winningUsername: string = null
  public winningImageURL: string = null
  public winningWhenJoined: Date = null
  public winningCollectorScore: number = null
  public winningFeedbackRating: number = null
  public winningAuctionScore: number = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  public constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.auction) this.auction = new Auction(this.auction)
    if (typeof this.sellerWhenJoined === 'string') this.sellerWhenJoined = new Date(this.sellerWhenJoined)
    if (typeof this.winningWhenJoined === 'string') this.winningWhenJoined = new Date(this.winningWhenJoined)
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  public getDiscountString(): string {
    if (this.discount === 0) return ''
    if (this.discount > 0) return `- ${Math.round(this.discount * 100)}%`
    if (this.discount < 0) return `+ ${-Math.round(this.discount * 100)}%`
  }

  public getDiscountClass(): string {
    if (this.discount === 0) return ''
    if (this.discount > 0) return 'positive'
    if (this.discount < 0) return 'negative'
  }

  public getImageClassNameBasedOnRarity(): string {
    if (this.isCommon() && !this.flowRetired) return 'imageMajorZoom'
    if (this.isCommon() && this.flowRetired) return 'imageMajorZoom'
    if (this.isFandom()) return 'imageMajorZoom'
    if (this.isRare()) return 'imageZoom'
    if (this.isLegendary()) return 'imageZoom'
    if (this.isUltimate()) return 'imageZoom'
  }

  public getPriceClassName(user: TokenUser): string {
    if (!user) return 'neutral'                     // not even logged in
    if (!this.usersHighestBid) return 'neutral'     // hasn't ever bid on this auction
    if (this.userIsHighestBidder(user)) return 'positive'
    return 'negative'
  }

  public userIsHighestBidder(user: TokenUser): boolean {
    if (!user) return false
    if (!this.usersHighestBid) return false
    if (this.auction.highestBidderUserId === user.getIdAsString()) return true
    if (user._temp && user._temp.account && utils_topshot.sansPrefix(this.auction.highestBidder) === utils_topshot.sansPrefix(user._temp.account.flowAddress)) return true
    return false
  }

  public getTimeLeftMS(): number {
    const nowTimeMS: number = new Date().getTime()
    const nowTimeWithServerAdjust: number = nowTimeMS + utils.getMsTimeServerIsAhead()
    const endTimeMS: number = this.auction.getCurrentEndDate().getTime()
    return endTimeMS - nowTimeWithServerAdjust
  }

  public niceEndsInTime(tick: number): string {
    const timeLeftMS: number = this.getTimeLeftMS()
    if (timeLeftMS <= 0) return `Ended ${utils_time.prettyTimeInFutureForAuctions(-timeLeftMS)} ago`
    if (this.auction.status === auctionStatus.Canceled) return 'Canceled'
    return utils_time.prettyTimeInFutureForAuctions(timeLeftMS)
  }

  public niceEndTime(): string {
    if (this.auction.endDate > this.auction.endDateBasedOnLatestBid) return this.auction.endDate.toLocaleString()
    return this.auction.endDateBasedOnLatestBid.toLocaleString()
  }

  public getClassNameForTimeLeft(): string {
    if (this.auction.status === auctionStatus.Canceled) return 'negative'
    const timeLeftMS: number = this.getTimeLeftMS()
    if (timeLeftMS < 300 * 1000) return 'negative'
    if (timeLeftMS < 3600 * 1000) return 'yellow'
    return 'neutral'
  }

  public getMinimumBid(): number {
    if (this.auction.numBids === 0) return this.auction.currentPrice
    return this.auction.currentPrice + Auction.getBidIncrement(this.auction.currentPrice)
  }

}

(async () => {
})();
